import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AcceptInvitationPage } from '@/pages/AcceptInvitation';

const searchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute('/invitations/accept')({
  component: AcceptInvitationPage,
  validateSearch: searchSchema,
});
